<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div class="title">{{$t('langNew.fxjl')}}</div>
        </div>
        <div class="cont-box">
            <vue-better-scroll class="wrapper"
                    ref="scroll"
                    :scrollbar="scrollbarObj"
                    :pullDownRefresh="pullDownRefreshObj"
                    :pullUpLoad="pullUpLoadObj"
                    :startY="parseInt(startY)"
                    :probeType="1"
                    :listenScroll=true
                    @scroll="scroll"
                    @pulling-down="onPullingDown"
                    @pulling-up="onPullingUp">
                <div class="num">{{this.$t('kjsy.zjlsl')}}{{sumMoney | toFixed}} GDCC</div>
                <ul class="table-th">
                    <li class="th">{{this.$t('kjsy.sj')}}</li>
                    <li class="th">{{this.$t('kjsy.sl')}}</li>
                    <li class="th">{{this.$t('kjsy.sm')}}</li>
                </ul>
                <div class="list-bg">
                    <ul class="ul-box">
                        <li class="list" v-for="(item,index) in listData" :key="index">
                            <div class="text">{{item.create_time | times2(timestamp)}}</div>
                            <div class="text">{{item.money}} ETH</div>
                            <div class="text">{{item.title}}</div>
                        </li>
                    </ul>
                </div>
            <no-data v-show="hasData"></no-data>
            </vue-better-scroll>
            <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        </div>
    </div>

</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that = this;
export default {
    name: 'kjsy',
    data () {
        return {
            curIdx: 1,
            uid: '',
            token: '',
            listData: [],
            hasData: false,
            isTop: false,
            sumMoney: 0,
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')
                }
            },
            startY: 0, // 纵轴方向初始化位置
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10,
            timestamp: 0
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token = localStorage.getItem('token');
        this.curIdx =  this.$route.query.curIdx;
        this.timestamp = localStorage.getItem('timestamp') || 0;
    },
    mounted() {
        this.getSumMoney()
        this.init()
    },
    methods: {
        goBack(){
            this.$router.push('/index');
        },
        getSumMoney(){
            let params = {
                uid: this.uid,
                token: this.token,
                type: this.curIdx
            }
            this.$ajax.post('/api/miningmachine/getSumMoney',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    this.sumMoney = resData.money;
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        init(){
            let params = {
                uid: this.uid,
                token: this.token,
                type: this.curIdx,
                limit: this.limit,
                page: this.page
            }
            this.$ajax.post('/api/miningmachine/mmProfit',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                     if(resData.length > 0){
                        this.hasData = false
                        this.listData = resData;
                        this.$refs.scroll.forceUpdate(true)
                    }else{
                        this.hasData = true;
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);
            })
        },
         /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = [];
            this.page = 1;
            this.init()
        },
        /* 上拉加载 */
        onPullingUp(){
            this.page ++;
            let params = {
                uid: this.uid,
                token: this.token,
                limit: this.limit,
                page: this.page
            }
            this.$ajax.post('/api/miningmachine/mmProfit',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 200){
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);
                        this.$refs.scroll.forceUpdate(true)
                    }else{
                         this.$refs.scroll.forceUpdate(false)
                    }
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        scroll({x, y}){
            if(Math.abs(y) >= 200){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },
        // 滚动到页面顶部
        scrollTo() {
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
        tab(idx){
            this.curIdx = idx;
            this.page = 1;
            this.listData  = [];
            this.getSumMoney();
            this.init()
        },
        jump(){
            this.$router.push('/pay')
        }
    },
    filters: {
        toFixed: function(val){
            return val.toFixed(4)
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
    },
    components:{
        navBar,
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .52rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .3rem;
        height: .6rem;
    }
    .tab-box{
        position: fixed;
        top: .8rem;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .46em .12rem .28rem;
        box-sizing: border-box;
    }
    .tab-box .tab{
        position: relative;
        color: #fff;
        font-size: .26rem;
        text-align: center;
    }
    .tab-box .tab.active{
        font-size: .3rem;
    }
    .tab-box .tab.active::after{
        position: absolute;
        left: 50%;
        bottom: -.2rem;
        content: '';
        width: .75rem;
        height: .04rem;
        margin-left: -.38rem;
        background: #2CAADE;
    }
    .cont-box{
        position: absolute;
        left: .24rem;
        right: .24rem;
        top: 1.6rem;
        bottom: 0;
        width: auto;
        height: auto;
        padding: 0 .18rem;
        color: #cecece;
        font-size: .36rem;
        background: rgba(4, 9 ,37,.2);
        border-radius: .14rem;
        box-sizing: border-box;
        overflow: hidden;
    }
    .num{
        padding: .34rem 0 .48rem;
        color: #2CAADE;
        font-size: .42rem;
        text-align: center;
    }
    .table-th{
        display: flex;
        align-items: center;
        padding-bottom: .32rem;
    }
    .table-th .th{
        width: 33.33%;
        color: #fff;
        font-size: .42rem;
        text-align: center;
    }
    .ul-box .list{
        display: flex;
        align-items: center;
        padding: .22rem 0;
    }
    .ul-box .list .text{
        width: 33.33%;
        color: #fff;
        font-size: .38rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/shareReward.vue